module.exports = __webpack_public_path__ + "static/media/downArrowWhite.70df702d.svg";